import { pipe } from 'fp-ts/lib/function';
import { chain, map } from 'fp-ts/lib/TaskEither';
import {
  createAuthorizedGetRequest,
  fetchApi,
  decode,
  PaginatableQuery,
  setQuery,
  encodePaginatableQuery,
} from '../..';
import { assigneesCodec } from '@/services/api/resources/assignee';

const baseUrl = '/v2/assignees';

export const list = (query: PaginatableQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodePaginatableQuery(query))),
  chain(fetchApi),
  chain(decode(assigneesCodec)),
);
